import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link, withRouter} from 'react-router-dom';
import ReactModal from 'react-modal';

import {Divider, Select} from 'components/common';
import Textarea from 'form/textarea';
import {Modal, CloseModal, ModalContent} from 'components/modal';
import {LinkDefault, ButtonWrap, ButtonDefault} from 'components/buttons';

import {loadUser} from 'redux/actions/auth';
import {checkRating} from 'redux/actions/portal/institutions';

import close from 'images/general/close.svg';

const mapStateToProps = (state) => ({
  user: state.auth.get('user'),
  token: state.auth.get('token'),
  ratingExist: state.institutions.get('ratingExist')
});

const mapDispatchToProps = (dispatch) => ({
  onLoad: () => dispatch(loadUser()),
  checkRatings: (user_id, doctor_id) => dispatch(checkRating(user_id, doctor_id)),
});

const showRating = (rating) => {
  switch(rating) {
    case "1":
      return "Дуже погано (1)";
    case "2":
      return "Погано (2)"
    case "3":
      return "Нормально (3)"
    case "4":
      return "Добре (4)"
    case "5":
      return "Дуже добре (5)"
    default:
  }
}

class Rating extends Component {

  componentDidMount() {
    if (!(this.props.user === undefined)) {
      this.props.checkRatings(this.props.user.get('id'), this.props.match.params.doctor)
    }
  }

  render() {

    if (!this.props.user || !this.props.ratingExist) {
      return (
        <ReactModal isOpen={this.props.modalOpenRating} onRequestClose={() => {
          this.props.toggleModalRating()
          this.props.openStep1()
        }}
          className={{
            base: 'modalContent',
            afterOpen: 'myClass_after-open',
            beforeClose: 'myClass_before-close'
          }} contentLabel="Підтвердження запису"
          overlayClassName={{
            base: 'modalOverlay',
            afterOpen: 'myOverlayClass_after-open',
            beforeClose: 'myOverlayClass_before-close'
          }}>
            <Modal>
              <CloseModal>
                <div onClick={(event) => {
                  this.props.toggleModalRating()
                  this.props.openStep1()
                }}>
                   <img src={close} alt="закрити" />
                </div>
              </CloseModal>
              <ModalContent>
                <h3>Для того, щоб залишити оцінку лікарю потрібно бути користувачем системи</h3>
                <h3>Якщо Ви зареєстрований користувач, <Link style={{color: "#edbd2f"}} to='/login'>увійдіть</Link> на портал</h3>
                <h3>Зареєструватися можна за цим <Link style={{color: "#edbd2f"}} to='/registration'>посиланням</Link></h3>
              </ModalContent>
            </Modal>
        </ReactModal>
      );
    }
    return (
      <ReactModal isOpen={this.props.modalOpenRating} onRequestClose={(event) => {
        this.props.toggleModalRating()
        this.props.openStep1()
        this.props.checkRatings(this.props.user.get('id'), this.props.match.params.doctor)
      }}
        className={{
          base: 'modalContent',
          afterOpen: 'myClass_after-open',
          beforeClose: 'myClass_before-close'
        }} contentLabel="Підтвердження запису"
        overlayClassName={{
          base: 'modalOverlay',
          afterOpen: 'myOverlayClass_after-open',
          beforeClose: 'myOverlayClass_before-close'
        }}>
        {!this.props.token ? (
          <Modal>
            <CloseModal>
              <div onClick={(event) => {
                this.props.toggleModalRating()
                this.props.openStep1()
              }}>
                 <img src={close} alt="закрити" />
              </div>
            </CloseModal>
            <ModalContent>
              <h3>Для того, щоб залишити оцінку потрібно бути користувачем системи</h3>
              <h3>Якщо Ви зареєстрований користувач, <Link style={{color: "#edbd2f"}} to='/login'>увійдіть</Link> на портал</h3>
              <h3>Зареєструватися можна за цим <Link style={{color: "#edbd2f"}} to='/registration'>посиланням</Link></h3>
            </ModalContent>
          </Modal>
        ):(
        <Modal>
          <CloseModal>
            <div onClick={(event) => {
              this.props.toggleModalRating()
              this.props.openStep1()
              this.props.checkRatings(this.props.user.get('id'), this.props.match.params.doctor)
            }}>
               <img src={close} alt="закрити" />
            </div>
          </CloseModal>
          {this.props.ratingExist.get('results').size > 0 ? (
            <ModalContent>
              <h3>Ви вже ставили оцінку цьому лікарю</h3>
              <Divider>
                <h3>Дякуємо, що робите нас кращими!</h3>
              </Divider>
            </ModalContent>
          ):(
          <div>
          {this.props.step1 &&
            <ModalContent>
            <h3>Оцінка лікарю</h3>
            <Select value={this.props.selectValue} onChange={this.props.handleChange}>
              <option value="1">Дуже погано (1)</option>
              <option value="2">Погано (2)</option>
              <option value="3">Нормально (3)</option>
              <option value="4">Добре (4)</option>
              <option value="5">Дуже добре (5)</option>
            </Select>
            <Textarea
              block
              label="Детальний опис: "
              value={this.props.comment}
              onChange={(event) => this.props.changeComment(event)}
              placeholder="Введіть детальний опис"
            />
            <ButtonWrap>
              <ButtonDefault onClick={() => this.props.openStep2()} value="Попередній перегляд" />
              <ButtonDefault value="Скасувати" onClick={(event) => {
                this.props.toggleModalRating()
                this.props.openStep1()
              }}/>
            </ButtonWrap>
          </ModalContent>
          }

              {/* {this.props.step2 && this.props.comment ? (
                  <ModalContent>
                      <h4>Всі поля обов’язкові до заповнення</h4>
                  </ModalContent>
              ):(
                  <div> */}
                      {this.props.step2 &&
                      <ModalContent>
                          <h3>Попередній перегляд оцінки</h3>
                          <Divider>
                              <div>Лікар: <strong>{this.props.staff.get('user_data').get('last_name')} {this.props.staff.get('user_data').get('first_name')} {this.props.staff.get('user_data').get('middle_name')}</strong></div>
                          </Divider>
                          <Divider>
                              <div>Оцінка лікарю: <strong>{showRating(this.props.selectValue)}</strong></div>
                          </Divider>
                          <Divider>
                              <div>Коментар: <strong>{this.props.comment}</strong></div>
                          </Divider>
                          <ButtonWrap>
                              <ButtonDefault onClick={() => {
                                  this.props.submitRating(this.props.match.params.doctor, this.props.user.get('id'), this.props.selectValue, this.props.comment)
                                  this.props.openStep3()
                              }} value="Відправити" />
                              <ButtonDefault value="Скасувати" onClick={(event) => {
                                  this.props.toggleModalRating()
                                  this.props.openStep1()
                              }}/>
                          </ButtonWrap>
                      </ModalContent>
                      }
                  {/* </div>
              )
              } */}


            {this.props.step3 &&
          <ModalContent>
            <h3>Ваша оцінка опублікована</h3>
            <Divider>
              <h4>Дякуємо за те, що намагаєтесь зробити нас кращими!</h4>
            </Divider>
            <Divider>
              <h4>Переглянути стан Вашої оцінки можна за цим <Link style={{color: "#edbd2f"}} to={this.props.ratingDetail === undefined ? `/`:  `/cabinet/rating/detail/${this.props.ratingDetail.get('id')}`}>посиланням</Link></h4>
            </Divider>
            <ButtonWrap>
              <LinkDefault to={this.props.ratingDetail === undefined ? `/`:  `/cabinet/rating/detail/${this.props.ratingDetail.get('id')}`}>До оцінки</LinkDefault>
              <ButtonDefault onClick={() => {
                this.props.toggleModalRating()
                this.props.openStep1()
                this.props.checkRatings(this.props.user.get('id'), this.props.match.params.doctor)
              }} value="До порталу" />
            </ButtonWrap>
          </ModalContent>
          }
        </div>)}
        </Modal>
        )}

      </ReactModal>
    )
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Rating));



// WEBPACK FOOTER //
// ./src/system/main/institutions/rating/index.js